const skuToIgnoreCOD = [
"44625684365533",
"44625684398301",
"45174187884765",
"44625684431069",
"44625684463837",
"45174187917533",
"44625684496605",
"44625684529373",
"45174187950301",
"42682941079773",
"43869167911133",
"42682941112541",
"43869167976669",
"44530194415837",
"44530194481373",
"43779049717981",
"43779049750749",
"44630811508957",
"43779049783517",
"43779049816285",
"44630811541725",
"43903484461277",
"43903484494045",
"44630811574493"
]
const skuToAppendCOD = [] 

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};

